import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteb2bAgnetApi,
  updateb2bAgnetApi,
} from "src/Api/Services/AgentFareRule";
import { useSnackbar } from "notistack5";
import useCustomConfirmSnackBar from "src/components/CustomComponents/useCustomConfirmSnackBar";
const AgentsFareRuleTabel = ({ getAgentData, editBtnClick, fetchData }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const showConfirmAlert = useCustomConfirmSnackBar();
  const { enqueueSnackbar } = useSnackbar();
  const handleDelete = async (id) => {
    try {
      const { data } = await deleteb2bAgnetApi(id);
      if (data.status) {
        fetchData();
      }
      enqueueSnackbar(data.message, {
        variant: data.status ? "success" : "error",
      });
    } catch (error) {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };
  return (
    <TableContainer
      className="tableairp-responsive"
      style={{ maxHeight: "none", height: "100%", marginTop: "20px" }}
    >
      <Table className="table-airp">
        <TableHead>
          <TableRow className="laststick-tr">
            {TableHeaderName.map((item, index) => (
              <TableCell key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {getAgentData
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((item, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.username}</TableCell>
                <TableCell>{item.password}</TableCell>
                <TableCell>{item.role}</TableCell>
                <TableCell>
                  {item.permissions?.pList[0]?.access?.join(", ")}
                </TableCell>
                <TableCell>
                  <div className="d-flex">
                    <div className="me-2">
                      <IconButton
                        aria-label="delete"
                        color="success"
                        onClick={() => editBtnClick(item)}
                      >
                        <EditIcon />
                      </IconButton>
                    </div>
                    <div>
                      {" "}
                      <IconButton
                        aria-label="delete"
                        color="error"
                        onClick={() =>
                          showConfirmAlert("Are you sure?", "warning", () =>
                            handleDelete(item._id),
                          )
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={getAgentData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, page) => setPage(page)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(+e.target.value);
          setPage(0);
        }}
      />
    </TableContainer>
  );
};

export default AgentsFareRuleTabel;
const TableHeaderName = [
  "S.No.",
  "User Name",
  "Password",
  "Role",
  "Permission",
  "Action",
];
